module.exports = __webpack_public_path__ + "img/20220327_191608.5e5230f4.jpg";